export function $<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

/**
 * Поля с `data-atv-autogrow` растут под текст.
 *
 * Нужно там, где пишут markdown: в поле на три строки не видно ни абзацев, ни
 * списков, и редактор правит текст вслепую. Обработчик вешается на документ
 * один раз и переживает перерисовку списков — сами поля создаются заново.
 */
let autoGrowBound = false;

function fitTextarea(el: HTMLTextAreaElement): void {
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight + 2}px`;
}

export function bindAutoGrowTextareas(): void {
  if (autoGrowBound) return;
  autoGrowBound = true;

  document.addEventListener('input', (e) => {
    const el = e.target as HTMLElement | null;
    if (el instanceof HTMLTextAreaElement && el.hasAttribute('data-atv-autogrow')) fitTextarea(el);
  });
}

/** Подогнать высоту уже вставленных полей — после перерисовки разметки. */
export function fitAutoGrowTextareas(root: ParentNode = document): void {
  root.querySelectorAll<HTMLTextAreaElement>('textarea[data-atv-autogrow]').forEach(fitTextarea);
}
